// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M16.5717 1.01367L22.9863 7.42827L22.11 11.7814L19.0679 14.8234L19.0719 14.8273C19.0103 14.8889 18.9442 14.9525 18.8735 15.0179L11.7833 22.1081L7.4302 22.9844L1.01562 16.5698L1.88954 12.2148L12.2167 1.88767L16.5717 1.01367ZM9.69294 18.1763L11.2898 19.7732L13.2592 17.8037C12.1975 18.0429 11.0078 18.1861 9.69294 18.1763ZM9.26342 20.5752L3.42361 14.7354L3.18729 15.913L8.08641 20.8122L9.26342 20.5752ZM4.31984 12.8032C10.7341 13.3003 14.6277 10.4229 16.6536 8.16643L12.71 4.22283L4.22471 12.7081L4.31984 12.8032ZM14.7373 3.4217L20.5771 9.26153L20.8141 8.08446L15.915 3.18535L14.7373 3.4217Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-cola-filled')
export default class ColaFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'cola-filled',
    }
  }
}
